import { useParams } from "react-router-dom";
import { useMutation } from "@apollo/client";
import AutoSizer, { Size } from "react-virtualized-auto-sizer";
import { UPDATE_BOX, REMOVE_BOX, tokenOptions } from "../../backend/graphql";
import { useAppSelector } from "../../app/hooks";
import { backendURL } from "../../constants";
import MaskEditor from "../widgets/MaskEditor";

// Correct one box sample's mask. The sample id is the route param, and the training endpoints serve
// its greyscale and mask blobs directly, so no extra query is needed. The greyscale is the only
// backdrop and it drives the autopaint threshold.
const BoxEdit = () => {
  const { id } = useParams();
  const token = useAppSelector((state) => state.auth.token);
  const [updateBox] = useMutation(UPDATE_BOX, tokenOptions(token));
  const [removeBox] = useMutation(REMOVE_BOX, tokenOptions(token));

  // The editor opens in its own tab, so each of save/delete/cancel closes it when done.
  const save = (mask: string) =>
    updateBox({ variables: { id, newMask: mask } }).then(() => window.close());

  const remove = () => removeBox({ variables: { id } }).then(() => window.close());

  return (
    <AutoSizer>
      {({ width, height }: Size) => (
        <div style={{ width, height }}>
          <MaskEditor
            size={128}
            backdrops={[{ key: "grayscale", label: "Diamond", src: `${backendURL}/training/box/${id}/grayscale` }]}
            srcMask={`${backendURL}/training/box/${id}/mask`}
            autopaint
            prefPrefix="box"
            onSave={save}
            onDelete={remove}
            onCancel={() => window.close()}
          />
        </div>
      )}
    </AutoSizer>
  );
};

export default BoxEdit;
